import { render, staticRenderFns } from "./administrationFormCreatorReportDetails.vue?vue&type=template&id=54ef91ee&"
import script from "./administrationFormCreatorReportDetails.vue?vue&type=script&lang=js&"
export * from "./administrationFormCreatorReportDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports